import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BLOGS_PER_PAGE = 6;

const BlogList = (props) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await fetch('/api/blogs');
                const data = await res.json();
                setBlogs(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching blogs:', error);
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return { day: '', month: '' };
        const date = new Date(dateString);
        return {
            day: date.getDate(),
            month: date.toLocaleDateString('en-AU', { month: 'short' })
        };
    };

    const totalPages = Math.ceil(blogs.length / BLOGS_PER_PAGE);
    const startIndex = (currentPage - 1) * BLOGS_PER_PAGE;
    const currentBlogs = blogs.slice(startIndex, startIndex + BLOGS_PER_PAGE);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            window.scrollTo(10, 0);
        }
    };

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <li key={i} className={currentPage === i ? 'active' : ''}>
                    <button onClick={() => handlePageChange(i)}>{i}</button>
                </li>
            );
        }

        return (
            <div className="pagination-wrapper pagination-wrapper-left">
                <ul className="pg-pagination">
                    <li>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            aria-label="Previous"
                            disabled={currentPage === 1}
                        >
                            <i className="fi ti-angle-left"></i>
                        </button>
                    </li>
                    {pages}
                    <li>
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                            disabled={currentPage === totalPages}
                        >
                            <i className="fi ti-angle-right"></i>
                        </button>
                    </li>
                </ul>
            </div>
        );
    };

    if (loading) {
        return (
            <section className={`blog-pg-section section-padding ${props.blnewclass}`}>
                <div className="container">
                    <div className="row">
                        <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                            <div style={{ textAlign: 'center', padding: '60px' }}>Loading blog posts...</div>
                        </div>
                        <BlogSidebar blLeft={props.blLeft} />
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={`blog-pg-section section-padding ${props.blnewclass}`}>
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            {currentBlogs.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '60px' }}>No blog posts found.</div>
                            ) : (
                                currentBlogs.map((blog, bitem) => {
                                    const dateInfo = formatDate(blog.published_at || blog.created_at);
                                    return (
                                        <div className="post format-standard-image" key={blog.id || bitem}>
                                            <div className="entry-media">
                                                <img src={blog.image_url || blog.thumb_url || '/images/blog/img-1.jpg'} alt={blog.title} />
                                                <span>{dateInfo.day}<br />{dateInfo.month}</span>
                                            </div>
                                            <div className="entry-meta">
                                                <ul>
                                                    <li><i className="fi flaticon-user"></i> By <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.author || 'PCIC Team'}</Link> </li>
                                                    <li><i className="fi ti-comment-alt"></i> Comments </li>
                                                    <li><i className="fi flaticon-clock"></i><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.read_time || '3 min Read'}</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="entry-details">
                                                <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h3>
                                                <p>{blog.description || blog.excerpt || ''}</p>
                                                <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`} className="read-more">READ MORE...</Link>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                            {renderPagination()}
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>
    )
}

export default BlogList;
